import { render, staticRenderFns } from "./variableReference.vue?vue&type=template&id=25259623&scoped=true"
import script from "./variableReference.vue?vue&type=script&lang=js"
export * from "./variableReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25259623",
  null
  
)

export default component.exports